import { connect } from "react-redux";
import Greeting from "./Greeting";
import { getCurrentUser } from "../../selectors/userSelectors";
import { getSubscriptionWithPendingPayment } from "../../selectors/subscriptionSelectors";

const mapStateToProps = (state) => ({
  user: getCurrentUser(state),
  subscription: getSubscriptionWithPendingPayment(state),
});

export default connect(mapStateToProps)(Greeting);
